export enum BREAKPOINTS {
  smallPalm = 480,
  mobile = 600,
  handheld = 800,
  portable = 1024
}
